import {
  ApolloClient,
  InMemoryCache,
  makeVar,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { LOCALSTORAGE_TOKEN } from "./contants";

const token = localStorage.getItem(LOCALSTORAGE_TOKEN);

export const isLoggedInVar = makeVar(Boolean(token));
export const authTokenVar = makeVar(token);
export const godModeVar = makeVar(false);
export const adminTokenVar = makeVar("");

// postgres://fvhsnyqlawxaze:7fb2f822d30ead29bded5ac6dbbc36b07cd93db44ce85a4463d17ca1572daaff@ec2-54-195-144-105.eu-west-1.compute.amazonaws.com:5432/dde50lrq5aftip
// export const url = "http://192.168.1.56:5000"
// export const url = "http://192.168.1.117";
// export const url = "http://192.168.0.122";
// export const url = "http://192.168.1.147";
// export const url = "https://scalance.cloud";
export const url = "https://scanart-846a0b6f1d8c.herokuapp.com";
export const uri = url + "/graphql";
// const uri = "http://192.168.1.156:4000/graphql"

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      // "x-jwt": authTokenVar() || null,
      "x-jwt":
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNzM1MDMyNTAwfQ.TcTUK7tteoB7YeO-S5V-Twukqu2-5u2WytQra4kzDdI",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),

  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // users: {
          //   // Don't cache separate results based on
          //   // any of this field's arguments.
          //   keyArgs: ["where", ["search", "role", "roles"]],
          //   // Concatenate the incoming list items with
          //   // the existing list items.
          //   merge(existing = {}, incoming, { args }): any {
          //     return {
          //       ...incoming,
          //       results: [...(existing.results || []), ...incoming.results],
          //     };
          //   },
          // },

          isLoggedIn: {
            read() {
              return isLoggedInVar();
            },
          },

          token: {
            read() {
              return authTokenVar();
            },
          },

          godMode: {
            read() {
              return godModeVar();
            },
          },
        },
      },
    },
  }),
});
